import { render } from "./custom-products.vue?vue&type=template&id=e4963744&ts=true"
import script from "./custom-products.ts?vue&type=script&lang=ts&external"
export * from "./custom-products.ts?vue&type=script&lang=ts&external"

import "./custom-products.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__